import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6643f9c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "empty-apps" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import CubeIcon from '@/assets/cube.png'

type Props = {
  title?: string
  description?: string
  width: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyCube',
  props: {
    title: {},
    description: {},
    width: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      style: _normalizeStyle({ width: `${_ctx.width}px` }),
      src: _unref(CubeIcon)
    }, null, 12 /* STYLE, PROPS */, _hoisted_2),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h6", _hoisted_3, _toDisplayString(_ctx.title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})